<div class="container">
  <div class="mt-5 mb-5">
    <div class="col-sm-1 filter-dropdown">
      <select name="parameters" [(ngModel)]="activeXML" (change)="updateXML(activeXML)">
        <option *ngFor="let xml of otherXmls" [value]="xml.title">{{ xml.title }}</option>
      </select>
    </div>
    <br>
    <br>
    <div class="gridcontainer">
      <div class="box">
        <h3>Request</h3>
        <app-prism-xml [xmlData]="requestXml"></app-prism-xml>
      </div>
      <div class="box">
        <h3>Response</h3>
        <app-prism-xml [xmlData]="responseXml"></app-prism-xml>
      </div>
    </div>




  </div>
</div>